export default __webpack_public_path__ + "static/media/data2.1bde2661.jpeg";